import type { ButtonPassThroughOptions } from 'primevue/button'

const pt: ButtonPassThroughOptions = {
    root: ({ props }) => ({
        class: [
            'inline-flex items-center justify-center gap-2',
            'rounded-6 font-semibold transition-all duration-fast',
            'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2',
            'disabled:opacity-50 disabled:cursor-not-allowed',
            // size
            props.size === 'small' && 'h-7 px-3 text-xs',
            props.size === 'large' && 'h-10 px-5 text-base',
            !props.size && 'h-9 px-4 text-sm',
            // severity
            (!props.severity || props.severity === 'primary') &&
                'bg-teal text-white hover:bg-teal-d focus-visible:outline-teal/55',
            props.severity === 'secondary' &&
                'bg-white text-gray-700 border border-gray-200 hover:border-gray-300 hover:bg-gray-50',
            props.severity === 'danger' && 'bg-red text-white hover:bg-red-text focus-visible:outline-red/55',
            props.severity === 'success' && 'bg-green text-white hover:bg-green-text',
            props.text && 'bg-transparent hover:bg-gray-100 border-none'
        ]
    }),
    label: { class: 'flex-none' },
    icon: { class: 'flex-none w-4 h-4' }
}

export default pt
